import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define interfaces for type safety
interface BookmarkCard {
  entity: string;
  title: string;
  description: string;
  [key: string]: any; // For any additional properties
}

interface UpdateBookmarkPayload {
  entity: string;
  title?: string;
  description?: string;
}

const initialState: BookmarkCard[] = [];

export const bookmarkCardsSlice = createSlice({
  name: 'bookmarkCards',
  initialState,
  reducers: {
    setBookmarkCards: (state, action: PayloadAction<BookmarkCard[]>) => {
      return action.payload;
    },
    addBookmarkCard: (state, action: PayloadAction<BookmarkCard>) => {
      state.push(action.payload);
    },
    removeBookmarkCard: (state, action: PayloadAction<string>) => {
      return state.filter((bmk) => bmk.entity !== action.payload);
    },
    updateBookmarkCard: (state, action: PayloadAction<UpdateBookmarkPayload>) => {
      const { entity, title, description } = action.payload;
      const bookmark = state.find((bmk) => bmk.entity === entity);
      if (bookmark) {
        if (title !== undefined) bookmark.title = title;
        if (description !== undefined) bookmark.description = description;
      }
    }
  }
});

export const { 
  setBookmarkCards,
  addBookmarkCard, 
  removeBookmarkCard, 
  updateBookmarkCard 
} = bookmarkCardsSlice.actions;
export default bookmarkCardsSlice.reducer;
